'use client'
import type { FC } from 'react'
import { Box, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { BiChevronRight } from 'react-icons/bi'
import { MdClose } from 'react-icons/md'
import { CategoryDTO } from 'ecosystem'
import { GrandIconButton, GrandNextLink } from 'ui'
import { usePathnameChanged } from 'ui/hooks'
import { sortCategories } from 'shared-utils'

export interface IMoreCategoriesSlideOutProps {
  category: CategoryDTO
  categoriesUrlPath: string
  onClose: () => void
}

const MoreCategoriesSlideOut: FC<IMoreCategoriesSlideOutProps> = ({
  category,
  categoriesUrlPath,
  onClose
}) => {
  usePathnameChanged(({ meta }) => {
    if (meta.isPathChanged) {
      onClose()
    }
  })

  return (
    <VStack spacing={10} w="100%">
      <HStack justify="space-between" w="100%">
        <Heading
          fontSize={{
            base: 'md',
            md: 'xl'
          }}
          isTruncated
        >
          {category.name}
        </Heading>

        <GrandIconButton
          aria-label="close"
          icon={<MdClose />}
          onClick={onClose}
          shadow="none"
          size="xs"
        />
      </HStack>

      <VStack align="stretch" spacing={2} w="100%">
        {sortCategories(category.subCategories || []).map((subcategory) => (
          <HStack cursor="pointer" key={subcategory.id} p={1}>
            <GrandNextLink href={`${categoriesUrlPath}/${subcategory.slug}`}>
              <Text flexGrow={1} isTruncated>
                {subcategory.name}
              </Text>
            </GrandNextLink>

            <Box>
              <BiChevronRight />
            </Box>
          </HStack>
        ))}
      </VStack>
    </VStack>
  )
}

export default MoreCategoriesSlideOut
